import React from 'react';
import starterPrompts from '../data/starterPrompts';

/**
 * Empty-state prompt chips. One click = send that prompt.
 * Only rendered when the transcript is empty.
 */

export default function PromptChips({ onPick, disabled }) {
  return (
    <div data-drishti="prompt-chips" className="flex flex-wrap gap-2">
      {starterPrompts.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onPick(p.label)}
          disabled={disabled}
          className="rounded-full border border-app-border/80 bg-white px-3.5 py-2 text-[12px] font-medium text-slate-700 shadow-sm transition-all duration-200 hover:-translate-y-[1px] hover:border-accent hover:bg-accent/5 hover:text-navy hover:shadow focus:outline-none focus:ring-2 focus:ring-accent disabled:cursor-not-allowed disabled:opacity-60"
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
